import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getApplicationDomain } from '../constants/apiEnvironments';
import { useLoginRedirect } from '../signup-completed-redirection/useLoginRedirect';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PendingEmailOAuthError = () => {
  const {
    redirectToLogin
  } = useLoginRedirect();
  const errorKey = ErrorKey.OAuthPendingEmailVerification;
  const onClick = () => {
    redirectToLogin({
      redirectUrl: `${getApplicationDomain()}/user-preferences/security`
    });
  };
  const renderContent = () => {
    return /*#__PURE__*/_jsx(View, {
      margin: "auto",
      marginBlock: "500",
      maxInlineSize: "500px",
      children: /*#__PURE__*/_jsx(CardWrapper, {
        padding: "500",
        children: /*#__PURE__*/_jsxs(Text, {
          textAlign: "start",
          typography: "body-200",
          children: [/*#__PURE__*/_jsx(View, {
            as: "div",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: `error.${errorKey}.howToFix`
            })
          }), /*#__PURE__*/_jsxs(List, {
            marginBlockEnd: "0",
            ordered: true,
            paddingInlineStart: "400",
            styled: true,
            children: [/*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `error.${errorKey}.step1`
              })
            }), /*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `error.${errorKey}.step2`
              })
            }), /*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `error.${errorKey}.step3`
              })
            }), /*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `error.${errorKey}.step4`
              })
            })]
          })]
        })
      })
    });
  };
  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    handleButtonClick: onClick,
    hasImage: false,
    linkToHelpResources: true,
    renderContent: renderContent
  });
};
export default PendingEmailOAuthError;